import React, { useEffect, useRef } from 'react';
import { Parser } from 'html-to-react';
import { UmbracoStep } from 'components/Umbraco/UmbracoContext';
import utils from 'utils';
import { Between, Center, ToggleGroup, useInput, LineSmall, ButtonSmall, LabelBig, LabelSubTitle, Paragraph, Row } from 'meitav-uikit';
import { isMobile } from "react-device-detect";
import { Button } from 'react-bootstrap';
const { UmbracoUtills, rest } = utils;

const PopUpExistingProcess = props => {
  const resourceStep = UmbracoStep(props.resource, `PopUpMiddleProcess`);
  const p = new Parser();

  const handleCick = (e) => {
    if (props.handleCick) {
      props.handleCick(e);
    }
    window.popupClose();
  }
  const handleClose = () => {
    if (props.handleClose) {
      props.handleClose();
    }
    window.popupClose();
  }


  return (
    <Row type='small'>
      <LabelSubTitle align="center">{p.parse(UmbracoUtills.getValueByKey(resourceStep, 'title'))}</LabelSubTitle>
      <Paragraph align="center">{p.parse(UmbracoUtills.getValueByKey(resourceStep, 'subTitle'))}</Paragraph>

      <LabelBig align="center" addClass='special'>{p.parse(UmbracoUtills.getValueByKey(resourceStep, 'joinInvestPolicyText').replace("@riskLevel", `${props.riskLevelName} [${props.riskLevel}/5]`).replace("@sectorName", props.sectorName))}</LabelBig>
      <LabelBig align="center" >{p.parse(UmbracoUtills.getValueByKey(resourceStep, 'joinInvestPolicyOk'))}</LabelBig>

      <LineSmall>
        <Center>
          <ButtonSmall text='כן' addClass='emptyColorGreen' onClick={() => handleCick('true')} />
          <ButtonSmall text='לא' addClass='emptyColorGreen' onClick={() => handleCick('false')} />
        </Center>
      </LineSmall>

    </Row>
  );
};

export default PopUpExistingProcess;
